import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { AnimatedSticky } from 'site-modules/shared/components/animated-sticky/animated-sticky';

import './sticky-step-heading.scss';

export function StickyStepHeading({
  stickyHeadingText = null,
  headingText = null,
  headingClassName = 'mt-2 mb-1_5 my-md-0',
  isMobile = false,
  children = null,
}) {
  const heading = !!headingText && (
    <h2 className={classnames('heading-4', headingClassName)} data-test="step-heading">
      {headingText}
    </h2>
  );

  const stickyFragment = (
    <Fragment>
      {!isMobile && (
        <div>
          <div className="heading-5">{stickyHeadingText}</div>
          <div className="heading-4">{headingText}</div>
        </div>
      )}
      {children}
    </Fragment>
  );

  return (
    <Fragment>
      <AnimatedSticky
        identifierClass="sticky-step-heading"
        stickyClassName="col-12 col-lg-7 d-flex justify-content-between align-items-center px-0 px-md-0_5 py-md-1_25"
        stickyFragment={stickyFragment}
        disableSticky={!children}
      >
        <div className="d-flex justify-content-between align-items-center py-md-1_25 px-0">
          {!isMobile && heading}
          {children}
        </div>
      </AnimatedSticky>
      {isMobile && heading}
    </Fragment>
  );
}

StickyStepHeading.propTypes = {
  headingText: PropTypes.string,
  headingClassName: PropTypes.string,
  stickyHeadingText: PropTypes.string,
  children: PropTypes.node,
  isMobile: PropTypes.bool,
};
